let Action = /*#__PURE__*/function (Action) {
  Action["RegisterKeyboardNavigationOption"] = "RegisterKeyboardNavigationOption";
  Action["UnregisterKeyboardNavigationOption"] = "UnregisterKeyboardNavigationOption";
  Action["IncrementSelectedIndex"] = "IncrementSelectedIndex";
  Action["DecrementSelectedIndex"] = "DecrementSelectedIndex";
  return Action;
}({});

export { Action };
